export default "__VITE_ASSET__BJ8Py$tQ__"